import { IonButton, IonIcon } from "@ionic/react";
import React from "react";
import calenderIcon from "../../../../theme/custom-icons/calendarIcon.svg";

const EmptyDateComponent: React.FC = () => {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "right",
        height: "41px",
        border: "1px solid #363E46",
        backgroundColor: "#001624",
      }}
    >
      <IonButton fill="clear" color={"dark"} disabled>
        <IonIcon icon={calenderIcon} slot="icon-only" />
      </IonButton>
    </div>
  );
};

export default EmptyDateComponent;
